import { render, staticRenderFns } from "./SubchannelTable.vue?vue&type=template&id=5a227690&"
import script from "./SubchannelTable.vue?vue&type=script&lang=js&"
export * from "./SubchannelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports